<style scoped="scoped" lang="scss">
.containter {
  padding: 0 20px 0;

  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  background-color: #fff;

  .card {
    width: 32.6%;
    min-width: 348.44px;
    margin-left: 5px;
    margin-right: 5px;
    margin-bottom: 10px;

    .card-title {
      font-size: 16px;
    }
  }
}
</style>

<template>
  <div class="containter">
    <el-card class="card">
      <div slot="header" class="clearfix">
        <span class="card-title">设备点检生成</span>
        <el-button style="float: right; padding: 3px" type="text" @click="reset1">{{ $t('chongzhi') }}</el-button>
        <el-button style="float: right; padding: 3px" type="text" :loading="loading1" @click="gen1">{{ $t('shengcheng') }}</el-button>
      </div>
      <div>
        <el-form size="mini" :inline="false" :model="conditions1" label-position="top">
          <el-form-item :label="$t('kehumingcheng')" required>
            <el-select v-model="conditions1.customerId" :placeholder="$t('qingxuanze')" filterable clearable @change="getEquipmentList">
              <el-option v-for="item in customerList" :key="item.id" :label="item.name" :value="item.id">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.code }} | {{ item.type }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')" required>
            <el-select v-model="conditions1.equipmentIds" multiple :placeholder="$t('qingxuanze')" filterable clearable collapse-tags :disabled="conditions1.customerId == null">
              <el-option v-for="item in equipmentList" :key="item.id" :label="item.name" :value="item.id">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.sn }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jihuadianjianriqi')" required>
            <yi_time_input type="daterange" :minTime="90 * 24 * 3600 * 1000" :maxTime="90 * 24 * 3600 * 1000" :is_current="false" :start.sync="conditions1.startTime" :end.sync="conditions1.endTime" format="yyyy-MM-dd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('jihuadianjianshijian')" required>
            <el-time-picker v-model="conditions1.time" value-format="HH:mm:ss" :placeholder="$t('qingxuanze')"> </el-time-picker>
          </el-form-item>
          <el-form-item :label="$t('dianjianren')" required>
            <yi_cross_select :max="1" component="admin_user_info_list" :ids.sync="conditions1.userId"> </yi_cross_select>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="card">
      <div slot="header" class="clearfix">
        <span class="card-title">设备效率补偿</span>
        <el-button style="float: right; padding: 3px" type="text" @click="reset2">{{ $t('chongzhi') }}</el-button>
        <el-button style="float: right; padding: 3px" type="text" :loading="loading2" @click="gen2">{{ $t('shengcheng') }}</el-button>
      </div>
      <div>
        <el-form size="mini" :inline="false" :model="conditions2" label-position="top">
          <el-form-item :label="$t('kehumingcheng')" required>
            <el-select v-model="conditions2.customerIds" :placeholder="$t('qingxuanze')" filterable clearable multiple collapse-tags>
              <el-option v-for="item in customerList" :key="item.id" :label="item.name" :value="item.id">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.code }} | {{ item.type }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('riqi')" required>
            <el-date-picker v-model="conditions2.date" value-format="yyyy-MM-dd" :placeholder="$t('qingxuanze')" :picker-options="pickerOptions2"> </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="card">
      <div slot="header" class="clearfix">
        <span class="card-title">基础产量补偿</span>
        <el-button style="float: right; padding: 3px" type="text" @click="reset3">{{ $t('chongzhi') }}</el-button>
        <el-button style="float: right; padding: 3px" type="text" :loading="loading3" @click="gen3">{{ $t('shengcheng') }}</el-button>
      </div>
      <div>
        <el-form size="mini" :inline="false" :model="conditions3" label-position="top">
          <el-form-item :label="$t('kehumingcheng')" required>
            <el-select v-model="conditions3.customerIds" :placeholder="$t('qingxuanze')" filterable clearable multiple collapse-tags>
              <el-option v-for="item in customerList" :key="item.id" :label="item.name" :value="item.id">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.code }} | {{ item.type }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('riqi')" required>
            <el-date-picker v-model="conditions3.date" value-format="yyyy-MM-dd" :placeholder="$t('qingxuanze')" :picker-options="pickerOptions2"> </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'admin_equipment_check_gen_index',
  components: {},
  data() {
    return {
      loading3: false,
      conditions3: {
        customerIds: [],
        date: null
      },
      loading2: false,
      conditions2: {
        customerIds: [],
        date: null
      },
      pickerOptions2: {
        disabledDate(time) {
          // 禁用今天及之后的日期
          return time.getTime() >= Date.now() - 8.64e7;
        }
      },
      conditions1: {
        customerId: null,
        equipmentIds: [],
        startTime: null,
        endTime: null,
        time: null,
        userId: null
      },
      customerList: [],
      equipmentList: [],
      loading1: false
    };
  },
  created() {
    this.getCustomerList();
  },
  methods: {
    // 生成3
    gen3() {
      this.loading3 = true;
      this.$message.success('提交成功, 正在生成中, 切勿重复提交...');
      this.http
        .post('/web/equipment/basic/production/gen', this.conditions3)
        .then(res => {
          this.$message.success('生成成功');
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.loading3 = false;
        });
    },
    // 生成2
    gen2() {
      this.loading2 = true;
      this.$message.success('提交成功, 正在生成中, 切勿重复提交...');
      this.http
        .post('/web/equipment/basic/efficiency/gen', this.conditions2)
        .then(res => {
          this.$message.success('生成成功');
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.loading2 = false;
        });
    },
    // 生成1
    gen1() {
      this.loading1 = true;
      this.$message.success('提交成功, 正在生成中, 切勿重复提交...');
      this.http
        .post('/web/equipment/check/bill/customGen', this.conditions1)
        .then(res => {
          this.$message.success('生成成功');
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.loading1 = false;
        });
    },
    // 重置3
    reset3() {
      this.conditions3 = {
        customerIds: [],
        date: null
      };
    },
    // 重置2
    reset2() {
      this.conditions2 = {
        customerIds: [],
        date: null
      };
    },
    // 重置1
    reset1() {
      this.conditions1 = {
        customerId: null,
        equipmentIds: [],
        startTime: null,
        endTime: null,
        time: null,
        userId: null
      };
    },
    // 获取客户列表
    getCustomerList() {
      this.http
        .get('/web/customer/list')
        .then(res => {
          this.customerList = res.data || [];
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    // 获取设备列表
    getEquipmentList() {
      this.http
        .get('/web/equipment/getByCustomerId?customerId=' + this.conditions1.customerId)
        .then(res => {
          this.equipmentList = res.data || [];
          this.conditions1.equipmentIds = [];
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    }
  }
};
</script>
